import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const ServicesSection = () => {
  const services = [
    {
      title: "Transactions Forestières",
      subtitle: "Carte T Réglementée",
      features: [
        "Acquisition et vente de parcelles forestières",
        "Intermédiation entre propriétaires privés",
        "Consolidation de propriétés morcelées",
        "Sourcing hors marché avec discrétion",
        "Rigueur juridique et due diligence complète",
      ],
    },
    {
      title: "Estimation & Valorisation",
      subtitle: "Analyse Patrimoniale",
      features: [
        "Analyse de la valeur foncière et du potentiel forestier",
        "Identification des options de valorisation",
        "Étude des opportunités liées aux bois",
        "Accompagnement dans la prise de décision",
        "Orientation vers les professionnels adaptés",
      ],
    },
    {
      title: "Succession & Indivision",
      subtitle: "Situations Complexes",
      features: [
        "Accompagnement des héritiers et familles",
        "Sortie d'indivision et structuration foncière",
        "Conseil en transmission patrimoniale",
        "Regroupement de parcelles dispersées",
        "Coordination avec notaires et conseils",
      ],
    },
    {
      title: "Remembrement Foncier",
      subtitle: "Assemblage Stratégique",
      features: [
        "Acquisition de parcelles pour créer des unités cohérentes",
        "Stratégies d'assemblage et d'échange foncier",
        "Regroupement de parcelles entre propriétaires",
        "Négociation avec diverses parties prenantes",
        "Structuration de propriété à long terme",
      ],
      link: "/remembrement-forestier",
    },
    {
      title: "Carbone Forestier",
      subtitle: "Projets Climat",
      features: [
        "Développement de projets carbone forestiers",
        "Mise en relation entreprises / propriétaires",
        "Structuration selon les standards reconnus",
        "Valorisation du potentiel de séquestration",
        "Suivi et traçabilité des projets",
      ],
      link: "#carbone",
    },
  ];

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-bone"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-sans font-semibold mb-4">
            Nos Expertises
          </p>
          <h2
            className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-forest"
            data-testid="services-headline"
          >
            Conseil en Foncier Forestier
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.slice(0, 3).map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="service-card bg-white p-8 md:p-10 border-l-4 border-gold"
              data-testid={`service-card-${index}`}
            >
              <p className="text-xs uppercase tracking-[0.15em] text-gold font-sans font-semibold mb-2">
                {service.subtitle}
              </p>
              <h3 className="font-serif text-xl md:text-2xl text-forest mb-6">
                {service.title}
              </h3>
              <ul className="space-y-3">
                {service.features.map((feature, fIndex) => (
                  <li
                    key={fIndex}
                    className="flex items-start text-sm text-gray-600"
                  >
                    <ArrowRight className="w-4 h-4 text-gold mr-2 mt-0.5 flex-shrink-0" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              {service.link && (
                <a
                  href={service.link}
                  className="inline-block mt-6 text-sm font-semibold text-forest hover:text-gold transition-colors"
                >
                  En savoir plus →
                </a>
              )}
            </motion.div>
          ))}
        </div>

        {/* Second row - 2 cards centered */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 max-w-4xl mx-auto">
          {services.slice(3).map((service, index) => (
            <motion.div
              key={index + 3}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: (index + 3) * 0.15 }}
              className="service-card bg-white p-8 md:p-10 border-l-4 border-gold"
              data-testid={`service-card-${index + 3}`}
            >
              <p className="text-xs uppercase tracking-[0.15em] text-gold font-sans font-semibold mb-2">
                {service.subtitle}
              </p>
              <h3 className="font-serif text-xl md:text-2xl text-forest mb-6">
                {service.title}
              </h3>
              <ul className="space-y-3">
                {service.features.map((feature, fIndex) => (
                  <li
                    key={fIndex}
                    className="flex items-start text-sm text-gray-600"
                  >
                    <ArrowRight className="w-4 h-4 text-gold mr-2 mt-0.5 flex-shrink-0" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              {service.link && (
                <a
                  href={service.link}
                  className="inline-block mt-6 text-sm font-semibold text-forest hover:text-gold transition-colors"
                >
                  En savoir plus →
                </a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
